<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
    <div class="row">
         <div class="col-4">

             <action-list [idPrefix]="idPrefix"
                          [items]="data.templates.items"
                          [selected]="selectedCategory"
                          [identifier]="'document_type'"
                          (select)="selectTemplateMetaList($event)">
             </action-list>

         </div>

         <div class="col-8">
             <mat-card>
                 <div class="row">
                     <div class="col-6">
                         <ng-container *ngFor="let template of selectedCategory.entries; let idx = index">
                             <div class="row no-gutters mb-2" *ngIf="showLeft(template)">
                                 <div class="col-12">
                                     <dr-checkbox [idPrefix]="idPrefix"
                                                  [idSuffix]="('item_' + idx)"
                                                  [boolValue]="templateIsSelected(template) || jobAlreadyContainsDocument(template)"
                                                  [label]="template.filename"
                                                  [disabled]="jobAlreadyContainsDocument(template)"
                                                  (updated)="toggleTemplateSelection(template, $event.value)">
                                     </dr-checkbox>
                                 </div>
                             </div>
                         </ng-container>
                     </div>

                     <div class="col-6">
                         <ng-container *ngFor="let template of selectedCategory.entries; let idx = index">
                             <div class="row no-gutters mb-2" *ngIf="!showLeft(template)">
                                 <div class="col-12">
                                     <dr-checkbox [idPrefix]="idPrefix"
                                                  [idSuffix]="('item_' + idx)"
                                                  [boolValue]="templateIsSelected(template) || jobAlreadyContainsDocument(template)"
                                                  [label]="template.filename"
                                                  [disabled]="jobAlreadyContainsDocument(template)"
                                                  (updated)="toggleTemplateSelection(template, $event.value)">
                                     </dr-checkbox>
                                 </div>
                             </div>
                         </ng-container>
                     </div>
                 </div>
             </mat-card>
         </div>
    </div>
</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" (click)="accept()">{{ 'common.btn.continue' | translate }}</button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.cancel" mat-stroked-button color="primary" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

</div>
